export default {
  interests: 'Interesses',
};
